// Zdrojová vrstva Phoenixem iniciované navigace do legacy Magicu — přemostění round-tripu.
//
// Legacy agenda se vždy otevře až tak, že Magic probublá zpět `form/open` a bridge na něj otevře
// vrstvu. Odkud navigace vzešla, pozná bridge ze `event.source`:
//   - navigace ZEVNITŘ legacy formuláře → zdroj je iframe okna → layerId přes `legacyFormSourceRegistry`,
//   - navigace z NATIVNÍ Phoenix UI (⋯/proklik v selektoru, tlačítko v tabulce, `onOpen` ListPage)
//     → jde přes SKRYTÝ control iframe, takže `event.source` žádné okno neidentifikuje.
//
// Bez druhé cesty by legacy detail otevřený z osamostatněného (floating) okna skončil na ploše
// místo ve stacku toho okna (native agendy dědí stack přes `useNavigator`/`objectCategoryNav`).
// Proto si tady odesílatel uloží layerId své vrstvy a bridge si ho při `form/open` vyzvedne.
//
// Modul je záměrně neutrální — žádná závislost na navigation/windowing/bridge vrstvách (stejná
// disciplína jako `layerReload` a `objectCategoryNav`), takže ho smí použít i `shared/ui`.

/** Consume-once slot: layerId vrstvy, ze které vzešla poslední Phoenixem iniciovaná legacy navigace. */
let pendingSourceLayerId: string | null = null;

/**
 * Zaznamená zdrojovou vrstvu pro NEJBLIŽŠÍ `form/open` z Magicu. Volá se těsně před postMessage
 * do control iframu (viz `useLegacyMessaging`, `sendMagicFormEdit`).
 *
 * `null` = navigace mimo vrstvu (plocha, menu, našeptávač) — záměrně i **maže** případný starší
 * záznam, aby zapomenutý záměr (Magic navigaci neprovedl) nepřetekl do navigace z plochy.
 */
export function setPendingLegacyNavSource(layerId: string | null): void {
  pendingSourceLayerId = layerId;
}

/** Vyzvedne a vymaže zaznamenanou zdrojovou vrstvu (consume-once). */
export function consumePendingLegacyNavSource(): string | null {
  const value = pendingSourceLayerId;
  pendingSourceLayerId = null;
  return value;
}
